import {
  GET_SPECIALTIES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_SPECIALTIES,
  UPDATE_SPECIALTIES,
  DELETE_SPECIALTIES,
} from "./actionType";

// common success
export const SpecialtiesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const SpecialtiesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Specialties = () => ({
  type: GET_SPECIALTIES,
});

export const CreateSpecialties = (data) => ({
  type: CREATE_SPECIALTIES,
  payload: { data },
});

export const UpdateSpecialties = (data) => ({
  type: UPDATE_SPECIALTIES,
  payload: { data },
});

export const DeleteSpecialties = (id) => ({
  type: DELETE_SPECIALTIES,
  payload: { id },
});
